import React, { useState, useRef } from "react";
import { useHistory } from "../../router/useHistory";
import axios from "axios";
import toast from "react-hot-toast";
import { connect } from "react-redux";
import "../../assets/css/auth.min.css";
import { Storage } from "react-jhipster";
import { Link } from "react-router-dom";
import I18n, { i18n } from "../private/languageSelector";
import { logout, getSession } from "../../redux/reducers/authentication/authentication";
import logo from "../../assets/images/tamam-logo-new.svg";
import { INPUT_VALUES_TO_EXCLUDE } from "../../config/constants";
import { TEXT_DIRECTION, jumpInputField, verifyAccountTranslation } from "../../helper/helperFunctions";
import { Card } from "../../components/card/Card";
import { Button } from "../../components/button/Button";

const VerifyAccount = ({ getSession, logout, setLaterActivate, user }) => {
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState({ message: "" });
  const [verificationNumber, setVerificationNumber] = useState(["", "", "", ""]);
  localStorage.setItem("language", user?.language);
  const language = localStorage.getItem("language") || user?.language || "ENGLISH";
  const inputRefs = useRef([]);

  const resendCode = () => {
    axios
      .post(`auth/send-verification-email`)
      .then(() => {
        toast.success(i18n("validation.VerificationCodeResent"), {
          style: {
            backgroundColor: "#FFF9CE",
            color: "#333333",
            fontSize: "14px",
            fontWeight: "500",
          },
          icon: false,
        });
      })
      .catch((error) => {
        setErrorMessage({
          message: error?.response?.data?.message || i18n("validation.AN_ERROR_OCCURED"),
        });
      });
  };

  const onSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    const code = verificationNumber.join("");
    if (!code) {
      setErrorMessage({ message: i18n("validation.REQUIRED_FIELD") });
      return;
    }
    axios
      .post(`auth/verify-email?token=${code}`)
      .then(() => {
        toast.success(i18n("validation.EMAIL_VERIFIED"));
        getSession();
      })
      .catch((error) => {
        setErrorMessage({ message: i18n("validation.INVALID_CODE") });
      });
  };

  const handleInputChange = (index, e) => {
    const newVerificationNumber = [...verificationNumber];
    newVerificationNumber[index] = e.target.value;
    setVerificationNumber(newVerificationNumber);

    if (e.target.value === "") {
      setErrorMessage({ message: "" }); // Clear error message if any field is cleared
    } else if (index < 3) {
      inputRefs.current[index + 1].focus(); // Move focus to the next input
    }

    jumpInputField(e, index, verificationNumber, setVerificationNumber);
  };

  const activateAccountLater = async () => {
    Storage.local.set("activate", "later");
    // Refresh session so the newly-created roleSetting (attached async by the
    // post-signup updateProfile call) lands in Redux before the sidebar mounts.
    // Without this, userRoleAccess stays {} on first login and all sidebar
    // tabs except the user profile are hidden until a manual refresh.
    try {
      await getSession();
    } catch (err) {
      // proceed even if refresh fails; worst case matches prior behavior
    }
    setLaterActivate(true);
  };

  return (
    <div className="w-100 bg-backgroundDark !min-h-[100vh] h-100 sm:w-100 flex justify-center flex-col items-center">
      <Card variant="primary" className=" bg-background !w-[350px] !pt-0 !p-0 rounded-tamam">
        {errorMessage.message && (
          <div className=" flex items-center justify-center rounded-t-[10px] h-9 bg-[#EB575733] !text-[#EB5757]">
            {/* <I18n lng="VerifyAccount.InvalidCodeHasExpired" /> */}
            {verifyAccountTranslation("InvalidCodeHasExpired", language)}
          </div>
        )}
        <div className="!p-4 !pb-7 pt-0">
          <div className={`mt-3 `}>
            <div className={`flex w-full`}>
              <img src={logo} alt="tamam-logo" className="w-[121px] h-[28px]  -mr-6" />
            </div>
            <h1 className={`my-3 text-[#333333] text-[1.125rem] flex  `}>
              {/* <I18n lng="VerifyAccount.ActivateAccount" /> */}
              {verifyAccountTranslation("ActivateAccount", language)}
            </h1>
          </div>
          <div className={`mt-3`}>
            <h1 className={`my-3 text-[#333333] text-sm ${language === "ARABIC" ? "!text-start" : "text-start"}`}>
              {/* <I18n lng="VerifyAccount.WehaveSentAVerificationCodeToYourEmail" /> */}
              {verifyAccountTranslation("WehaveSentAVerificationCodeToYourEmail", language)}
            </h1>
          </div>
          <form autoComplete="off" onSubmit={onSubmit}>
            <div className="flex justify-between mb-3 " style={{ direction: "ltr" }}>
              {verificationNumber.map((value, index) => (
                <div className=" remove-arrows" key={index}>
                  <input
                    type="text"
                    maxLength="1"
                    className="bg-[#F2F2F2] rounded-md w-[60px] h-[60px] text-center !focus:outline-none !outline-none !focus:border-none !border-none"
                    value={value}
                    ref={(el) => (inputRefs.current[index] = el)}
                    onKeyDown={(e) => INPUT_VALUES_TO_EXCLUDE.includes(e.key) && e.preventDefault()}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </div>
              ))}
            </div>
            <Button
              variant={verificationNumber.every((num) => num) ? "secondary" : "primary"}
              title={verifyAccountTranslation("Verify", language)}
              type="submit"
              disabled={verificationNumber.some((num) => num === "")}
              className="w-100 uppercase"
            />
          </form>
        </div>
      </Card>

      <div
        className={` mt-3 text-[#333333] max-h-[534px] h-auto min-w-[350px]`}
        // style={{ direction: TEXT_DIRECTION() }}
      >
        <div className={`flex items-center justify-between w-100 ${language === "ARABIC" ? "" : ""}`}>
          <div>
            <span
              className={`mr-1 ml-1 ${language === "ARABIC" ? "" : ""} ${
                TEXT_DIRECTION() === "rtl" ? " float-right" : " float-left"
              } fw-[500] text-[14px]`}
            >
              {/* <I18n lng="VerifyAccount.DidntReceivedTheCodeYet" /> */}
              {verifyAccountTranslation("DidntReceivedTheCodeYet", language)}
              <Link
                to="/#"
                onClick={(e) => {
                  e.preventDefault();
                  resendCode();
                }}
                className="text-colPrimary hover:no-underline hover:text-colPrimary ml-1 mr-1"
              >
                {/* {i18n("VerifyAccount.Resend")} */}
                {verifyAccountTranslation("Resend", language)}
              </Link>
            </span>
          </div>
          <div className="text-[14px] fw-[500] text-[#333333]" style={{ fontWeight: 500 }}>
            <Link
              to="#"
              className="hover:no-underline"
              onClick={(e) => {
                e.preventDefault();
                activateAccountLater();
                history.push("/");
              }}
            >
              {/* <I18n lng="VerifyAccount.Skip" /> */}
              {verifyAccountTranslation("Skip", language)}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ authentication }) => ({
  isAuthenticated: authentication.isAuthenticated,
  user: authentication.user,
});

const mapDispatchToProps = { getSession, logout };

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAccount);
